import { useState } from 'react';
import { Box, Grid } from '@mui/material';
import { styled } from 'styled-components';

const ColorSwatchButton = styled('div')`
    border: 2px solid ${({ theme }) => theme.vars.palette.grey[200]};
    padding: ${({ theme }) => theme.spacing(0.5, 0.5)};
    border-radius: ${({ theme }) => theme.shape.borderRadius}px;
    overflow: hidden;
    height: 70px;
    cursor: pointer;
    display: flex;

    &:hover,
    &.active {
        border-color: ${({ theme }) => theme.vars.palette.grey[500]};
    }
`;

interface IProps {
    selectedColor?: string;
    onChange?(color: string): void;
}

// Onboarding color presets
export const PRIMARY_COLOR_PRESETS = {
    'preset-1': '#11B683',
    'preset-2': '#2EB3C7',
    'preset-3': '#D94905',
    'preset-4': '#F7C248',
    'preset-5': '#7E29A2',
};

export const BaseColorPicker = ({ selectedColor, onChange }: IProps) => {
    const [selected, setSelected] = useState<string | undefined>(selectedColor);

    return (
        <Grid container spacing={2}>
            {Object.values(PRIMARY_COLOR_PRESETS).map((color) => (
                <Grid key={color} size={{ md: 'grow', sm: 4, xs: 4 }}>
                    <ColorSwatchButton
                        className={color === selected ? 'active' : ''}
                        onClick={() => {
                            setSelected(color);
                            onChange && onChange(color);
                        }}
                    >
                        <Box sx={{ bgcolor: color, flex: '1' }} />
                    </ColorSwatchButton>
                </Grid>
            ))}
        </Grid>
    );
};
